document.addEventListener('DOMContentLoaded', () => {
  const placeholders = document.querySelectorAll('.js-variant-list-placeholder');

  if (placeholders.length === 0) {
    return;
  }

  const masterSizeOrder = [
    'x-small', 'extra small', 'small', 'medium', 'large', 'x-large', 'xx-large', 'xxx-large',
  ];

  placeholders.forEach(placeholder => {
    const productId = placeholder.dataset.productId;
    const variantJsonScript = document.querySelector(`script[data-variant-json-for-product="${productId}"]`);
    
    // Get the product option names and the product URL from the data attributes
    const productOptions = JSON.parse(placeholder.dataset.productOptions || '[]');
    const productUrl = placeholder.dataset.productUrl;

    if (!variantJsonScript || !productOptions || !productUrl) return;

    const variants = JSON.parse(variantJsonScript.innerHTML);
    if (!variants || variants.length === 0) return;

    let sizeOptionKey = null;
    const sizeIndex = productOptions.findIndex(name => name && name.toLowerCase() === 'size');

    if (sizeIndex !== -1) {
      sizeOptionKey = `option${sizeIndex + 1}`;
    }
    
    if (!sizeOptionKey) return;

    const allSizes = variants.map(v => v[sizeOptionKey]);
    const availableSizes = variants.filter(v => v.available).map(v => v[sizeOptionKey]);
    const allUniqueSizes = [...new Set(allSizes)];
    const availableUniqueSizes = [...new Set(availableSizes)];
    
    let finalHtml = '';
    const printedSizes = new Set();

    // 1. Loop through the master order to sort standard sizes
    masterSizeOrder.forEach(masterSize => {
      const originalSizeValue = allUniqueSizes.find(s => s && s.toLowerCase().trim() === masterSize);
      if (originalSizeValue && !printedSizes.has(originalSizeValue)) {
        const isSoldOut = !availableUniqueSizes.includes(originalSizeValue);
        const cssClass = isSoldOut ? 'collection-product-variants__item is-sold-out' : 'collection-product-variants__item';
        
        let sizeAbbreviation = '';
        switch (originalSizeValue.toLowerCase().trim()) {
          case 'x-small': case 'extra small': sizeAbbreviation = 'XS'; break;
          case 'small': sizeAbbreviation = 'S'; break;
          case 'medium': sizeAbbreviation = 'M'; break;
          case 'large': sizeAbbreviation = 'L'; break;
          case 'x-large': sizeAbbreviation = 'XL'; break;
          case 'xx-large': sizeAbbreviation = 'XXL'; break;
          case 'xxx-large': sizeAbbreviation = 'XXXL'; break;
          default: sizeAbbreviation = originalSizeValue;
        }
        // THE CHANGE: Build an <a> tag instead of a <div>
        finalHtml += `<a href="${productUrl}" class="${cssClass}">${sizeAbbreviation}</a>`;
        printedSizes.add(originalSizeValue);
      }
    });

    // 2. Loop through the rest of the sizes to add any non-standard ones
    allUniqueSizes.forEach(size => {
      if (size && !printedSizes.has(size)) {
        const isSoldOut = !availableUniqueSizes.includes(size);
        const cssClass = isSoldOut ? 'collection-product-variants__item is-sold-out' : 'collection-product-variants__item';
        // THE CHANGE: Build an <a> tag instead of a <div>
        finalHtml += `<a href="${productUrl}" class="${cssClass}">${size}</a>`;
      }
    });

    if (finalHtml) {
      placeholder.innerHTML = `
        <div class="collection-product-variants__sizes">
          <div class="collection-product-variants__list">
            ${finalHtml}
          </div>
        </div>
      `;
    }
  });
});